import { Switch } from 'antd';
import styles from './business-hours-switch.module.scss';

interface BusinessHoursSwitchProps {
  onChange: (checked: boolean) => void;
  defaultChecked?: boolean;
}

export function BusinessHoursSwitch({ onChange, defaultChecked }: BusinessHoursSwitchProps) {
  return (
    <Switch
      className={styles.businessHoursSwitch}
      defaultChecked={defaultChecked}
      onChange={onChange}
    />
  );
}
